import { Col, Modal, Row } from "reactstrap";

interface DeleteModalProps {
  show: any;
  onDeleteClick: any;
  onCloseClick: any;
}

const DeleteModal = ({
  show,
  onDeleteClick,
  onCloseClick,
}: DeleteModalProps) => {
  return (
    <Modal isOpen={show} toggle={onCloseClick} centered={true} size="sm">
      <button
        onClick={onCloseClick}
        type="button"
        className="close position-absolute confirm-modal-close"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <div className="modal-body pt-4">
        <div className="text-center mb-3">
          <i className="mdi mdi-alert-circle-outline confirm-modal-icon" />
          <h5 className="mt-2">Are you sure?</h5>
          <p>{"You won't be able to revert this!"}</p>
        </div>
        <hr className="my-3" />
        <Row className="g-2 justify-content-between">
          <Col xs={6} md="auto">
            <button
              type="button"
              className="btn btn-primary button-primary w-100"
              onClick={onDeleteClick}
            >
              <i className="mdi mdi-trash-can-outline me-1"></i>
              Yes, delete it!
            </button>
          </Col>
          <Col xs={6} md="auto">
            <button
              type="button"
              className="btn btn-danger button-secondary confirm-modal-cancel w-100"
              onClick={onCloseClick}
            >
              <i className="mdi mdi-close me-1"></i>
              Cancel
            </button>
          </Col>
        </Row>
      </div>
    </Modal>
  );
};

export default DeleteModal;
